import React from "react";
import { IKImage } from "imagekitio-next";

type BlogImagePropsType = {
  imageName: string;
  alt: string;
  className: string;
  imageUrl: string;
};

// const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL + "yawakit_blog/tr:w-800";
const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL_BLOG_IMG;

const BlogImageWidth = 500;
const BlogImageHeight = 500;

const BlogImage = (props: BlogImagePropsType) => {
  return (
    <IKImage
      src={`${urlEndpoint}${props?.imageUrl || "default_image.jpg"}`}
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      transformation={[{ crop: "maintain_ratio" }]}
      width={BlogImageWidth}
      height={BlogImageHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className={`${props.className}`}
    />
  );
};

export default BlogImage;
